<template>
  <div>
    <div class="login">
      <div class="loginbody container">
        <h2 class="title_font2">{{$t('login.login')}}</h2>
        <v-line></v-line>
        <form method="POST" action="/login" @submit="CheckLogin">
          <input type="hidden" name="_token" :value="token" />
          <div class="inputgroup">
            <ul class="row" style="padding-left: 0" v-if="error_email">
              <li class="col-md-4 col-12 offset-md-4 page_text_font" id="loginerror">{{error_email}}</li>
            </ul>
            <div class="row">
              <input
                type="email"
                class="col-md-4 col-12 offset-md-4 page_text_font"
                name="email"
                required
                autocomplete="email"
                autofocus
                :placeholder="$t('login.email')"
                v-model="email"
              />
            </div>
            <div class="row">
              <input
                id="password"
                type="password"
                class="col-md-4 col-12 offset-md-4 page_text_font"
                :placeholder="$t('login.password')"
                name="password"
                required
                autocomplete="current-password"
              />
            </div>
            <div class="row">
              <button
                type="submit"
                class="col-md-4 col-12 offset-md-4 main_button secondary_title"
                id="loginbtn"
                :class="[themeStyleRadius == 'circle' ? 'button-radius' : '']"
              >{{$t('login.sign_in')}}</button>
            </div>
            <p>
              <a class="secondary_title" href="/account/register">{{$t('login.create_account')}}</a>
            </p>
            <p>
              <a class="secondary_title" href="/">{{$t('login.return_to_store')}}</a>
            </p>
            <p>
              <a
                class="secondary_title"
                href="/login#recover"
                @click.prevent="hiddenlogin"
              >{{$t('login.forgot_password')}}</a>
            </p>
            <v-social-auth v-if="social_auth" :social_auth="social_auth" class="text-center"></v-social-auth>
          </div>
        </form>
      </div>
    </div>
    <div class="forgotpassword" style="display: none">
      <div class="forgotpasswordbody">
        <h2 class="secondary_title">{{$t('login.reset_password')}}</h2>
        <v-line></v-line>
        <p class="secondary_title">{{$t('login.send_email')}}</p>
        <form method="POST" action="/password/email" @submit="CheckForgot">
          <input type="hidden" name="_token" :value="token" />
          <div class="inputgroup container">
            <ul class="row" style="padding-left: 0" v-if="error_forgote">
              <li
                class="col-md-4 offset-md-4 col-12 page_text_font"
                id="forgoterror"
              >{{ error_forgote }}</li>
            </ul>
            <div class="row">
              <input
                type="email"
                :placeholder="$t('login.email')"
                class="col-md-4 offset-md-4 col-12 page_text_font"
                name="email"
                required
                autocomplete="email"
                v-model="email"
                autofocus
              />
              <!-- <input type="text" placeholder="Email" class="col-md-4 offset-md-4 col-12" v-model="email" @blur="regexemail" /> -->
            </div>
            <div class="row">
              <button
                class="col-md-4 offset-md-4 col-12 main_button secondary_title"
                id="forgotbtn"
                :class="[themeStyleRadius == 'circle' ? 'button-radius' : '']"
              >{{$t('login.submit')}}</button>
            </div>
            <p>
              <a
                class="secondary_title"
                href="/login"
                @click.prevent="hiddenlogin"
              >{{$t('login.cancel')}}</a>
            </p>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import vSocialAuth  from "@/js/components/view/socialauth/index.vue"
export default {
  props: ["error_email", "error_forgote","social_auth"],
  data() {
    return {
      errormessage: "",
      errorshow: false,
      email: "",
      password: "",
      token: document.head.querySelector('meta[name="csrf-token"]').content
    };
  },
  computed: {
    ...mapState({
      themeStyleRadius: ({ options }) => options?.theme?.global?.style?.type || "",
    })
  },
  methods: {
    CheckLogin() {
      window.localStorage.setItem("login_email", this.email);
      $("#loginbtn").attr("disabled", "true");
      $("#loginbtn").css("cursor", "wait");
      $("#loginbtn").css("background", "gray");
      $("body").css("cursor", "wait");
      //登录时snapchat的 LOGIN 事件
      if(window.snaptr){
        window.snaptr('track', 'LOGIN')
      }
      return true;
    },
    hiddenlogin(event) {
      var ev = ev || window.event;
      ev.preventDefault();
      this.$(".login").toggle();
      this.$(".forgotpassword").toggle();
    },
    CheckForgot() {
      window.localStorage.setItem("login_email", this.email);
      this.$("#forgotbtn").attr("disabled", "true");
      this.$("#forgotbtn").css("cursor", "wait");
      this.$("#forgotbtn").css("cursor", "gray");
      this.$("body").css("cursor", "wait");
      return true;
    }
  },
  mounted() {
    if (window.location.hash == "#recover") {
      console.log(111111);
      this.$(".login").hide();
      this.$(".forgotpassword").show();
    }
    if (this.error_email || this.error_forgote) {
      this.email = window.localStorage.getItem("login_email");
      this.$axios.post(API.statis_event, {
        name: 'login',
        parameters: { username: this.email, success: false },
      }) 
    }
  },
  components:{
    vSocialAuth,
  }
};
</script>
<style scoped lang='scss'>
.login {
  .loginbody {
    padding-top: 80px;

    text-align: center;
    h2 {
      margin-top: 16px;
    }
    .inputgroup {
      margin-top: 50px;
      padding: 0 30px;

      input,
      button {
        height: 44px;
        padding: 8px 10px;
        background: #f6f6f6;
        border: none;
        margin-bottom: 10px;
      }

      button {
        background: rgb(201, 13, 13);
        color: white;
      }
      button:hover {
        background: rgb(241, 34, 34);
      }
      button:active {
        background: rgb(86, 6, 6);
      }

      a {
        text-decoration: none;
        color: black;
        font-size: 12px;
      }

      ul {
        li {
          list-style-type: disc;
          list-style-position: inside;
          background-color: #fff6f6;
          border: 1px solid red;
          color: red;
          line-height: 28px;
          font-size: 12px;
          text-align: left;
          padding-left: 10px;
        }
      }
    }
  }
}
.forgotpassword {
  .forgotpasswordbody {
    padding-top: 80px;
    text-align: center;
    font-weight: normal;
    h2 {
      margin-top: 16px;
      font-weight: normal !important;
    }

    .inputgroup {
      padding: 0 30px;

      input,
      button {
        height: 44px;
        padding: 8px 10px;
        background: #f6f6f6;
        border: none;
        margin-bottom: 10px;
      }

      button {
        background: rgb(201, 13, 13);
        color: white;
      }
      button:hover {
        background: rgb(241, 34, 34);
      }
      button:active {
        background: rgb(86, 6, 6);
      }

      a {
        text-decoration: none;
        color: black;
        font-size: 12px;
      }

      ul {
        li {
          list-style-type: disc;
          list-style-position: inside;
          background-color: #fff6f6;
          border: 1px solid red;
          color: red;
          line-height: 28px;
          font-size: 12px;
          text-align: left;
          padding-left: 10px;
        }
      }
    }
  }
}
</style>